<template>
  <div class="fff-modal recipe-details-modal">
    <div
      class="overlay"
      @click="$emit('close')"
    />
    <div class="box">
      <div
        class="close-modal"
        @click="$emit('close')"
      >
        &times;
      </div>

      <h4>Recipe: <strong>{{ recipe.name }}</strong></h4>
      <h6>Your current FOOD SPIRAL®: <strong>{{ $store.state.user.user['food-spiral'][0].name }}</strong></h6>

      <div class="image-split">
        <div
          v-if="recipe.image_url"
          class="side graphic"
        >
          <div
            class="image"
            :style="{'background-image': 'url(' + recipe.image_url + ')'}"
            :class="[ recipe.image_url ? 'print-bg' : '' ]"
          />
        </div>
        <div class="side info">
          <div
            class="food-factor-circle"
            :class="[recipe.food_color.toLowerCase()]"
          >
            <auto-fit-text>{{ recipe.food_factor }}</auto-fit-text>
          </div>
          <div
            class="food-factor-label"
            :class="[recipe.food_color]"
          >
            Food Factor &amp; Color
          </div>
          <div class="food-metas line-items">
            <div class="line-item">
              <div class="label">
                Total Servings
              </div>
              <div class="space" />
              <div class="value">
                {{ recipe.number_of_servings }}
              </div>
            </div>
            <div class="line-item">
              <div class="label">
                Single Serving
              </div>
              <div class="space" />
              <div class="value">
                {{ recipe.display_single }} {{ recipe.display_unit }}
              </div>
            </div>
            <div class="line-item">
              <div class="label">
                Recipe Makes
              </div>
              <div class="space" />
              <div class="value">
                {{ recipe.display_total }} {{ recipe.display_unit }}
              </div>
            </div>
            <div class="line-item">
              <div class="label">
                Allergens
              </div>
              <div class="space" />
              <div
                v-if="recipe.allergens.length > 0"
                class="value"
              >
                {{ recipe.allergens.join(', ') }}
              </div>
              <div
                v-else
                class="value"
              >
                N/A
              </div>
            </div>
            <div class="line-item">
              <div class="label">
                Food Groups
              </div>
              <div class="space" />
              <div
                v-if="recipe.food_groups.length > 0"
                class="value"
              >
                {{ recipe.food_groups.join(', ') }}
              </div>
              <div
                v-else
                class="value"
              >
                N/A
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="instructions my-4">
        <h6 style="margin-bottom: 24px;">
          <strong>Instructions</strong>
        </h6>
        <p>{{ recipe.directions }}</p>
      </div>

      <h6 class="my-4">
        <strong>Ingredients</strong>
      </h6>

      <div class="ingredients line-items">
        <div
          v-for="ingredient in recipe.ingredients"
          class="line-item"
        >
          <div
            class="label"
            :class="[recipe.food_color]"
          >
            {{ ingredient.name }}
          </div>
          <div class="space" />
          <div class="value">
            {{ ingredient.ingredient_quantity }} {{ ingredient.display_unit }}
          </div>
        </div>
      </div>

      <div class="buttons">
        <div
          class="action favorite"
          :class="{ on: recipe.is_favorited }"
          @click="$emit('toggle-favorite', recipe)"
        >
          <div class="icon">
            <i
              v-show="recipe.is_favorited"
              class="fas fa-heart"
            />
            <i
              v-show="!recipe.is_favorited"
              class="far fa-heart"
            />
          </div>
          <span>{{ recipe.is_favorited ? 'In Your Favorites' : 'Add to Favorites' }}</span>
          <i
            v-tooltip:top="'Do you eat this food frequently? If so, add it to your favorites for quicker food entries next time!'"
            class="text-primary fa fa-info-circle"
          />
        </div>
        <div class="action log">
          <slot name="actions" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecipeDetailsModal",
  props: {
    recipe: Object
  }
}
</script>
